//this file set-up-two-factor-authentication represents an api object.  A file, and api object of the same name exists
//as a duplicate to facilitate calling this api from public and private (app-base/public and manager-base/api respectively) contexts.
//api methods to be used by components in both contexts (eg. generateQRCode, etc) should therefore remain in sync.

import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    sendTwoFactorCode: {
        method: 'PUT',
        url: `${BASE_PATH_API}/twoFactorAuthentication/sendCode`
    },
    verifyTwoFactorCode: {
        method: 'PUT',
        url: `${BASE_PATH_API}/twoFactorAuthentication/verifyCode`
    },
    generateQRCode: {
        method: 'POST',
        url: `${BASE_PATH_API}/twoFactorAuthentication/generateQRCode`
    },
    createTwoFactorConfigurationAndSecret: {
        method: 'POST',
        url: `${BASE_PATH_API}/twoFactorAuthentication/configuration`
    },
    getUserTwoFactorConfiguration: {
        method: 'GET',
        url: `${BASE_PATH_API}/twoFactorAuthentication/configuration`
    },
    deleteUserTwoFactorBackupMethod: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/twoFactorAuthentication/twoFactorBackupMethod`
    },
    getTwoFactorSecretKey: {
        method: 'GET',
        url: `${BASE_PATH_API}/twoFactorAuthentication/secretKey`
    },
    isDeviceRemembered: {
        method: 'GET',
        url: `${BASE_PATH_API}/twoFactorAuthentication/deviceRemembered`
    }
};

export function SetupTwoFactorAuthenticationApi() {
    return createActions(actions);
}
